import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';

type Props = {
  modelValue: boolean; // dialog visibility
  value: string; // current field value
  label: string; // dialog title
  placeholder: string; // input placeholder
  disabled?: boolean; // sponsor lock
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ScopeDialog',
  props: {
    modelValue: { type: Boolean, required: true },
    value: { type: String, required: true },
    label: { type: String, required: true },
    placeholder: { type: String, required: true },
    disabled: { type: Boolean, required: false }
  },
  emits: ['update:modelValue', 'save', 'clear', 'close'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: boolean; // dialog visibility
  value: string; // current field value
  label: string; // dialog title
  placeholder: string; // input placeholder
  disabled?: boolean; // sponsor lock
};




const model = computed({
  get: () => props.modelValue,
  set: v => emit('update:modelValue', v)
});

const localValue = ref(props.value);
watch(
  () => props.value,
  v => (localValue.value = v)
);

function onSave() {
  emit('save', localValue.value);
  emit('update:modelValue', false);
}

function onClear() {
  emit('clear');
  localValue.value = '';
}

return { __sfc: true,props, emit, model, localValue, onSave, onClear }
}

})